import { getModule, Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import { store } from '@/iti-core-vue';
import { LerCode } from '@/shared/dtos/ler-code';
import { itiTokenService } from '@/iti-core-vue/services/iti-token-service';
import { ItiString, itiHttpService } from '@/iti-core-vue';
import { API } from '@/shared/api';



@Module({
    namespaced: true,
    name: 'LerCodeModule',
    store,
    dynamic: true,
})

class LerCodeModule extends VuexModule implements BaseModule {
    public lerCodes: LerCode[] = [];

    @Mutation
    public resetState(): void {
        this.lerCodes = [];
    }

    @Action
    public async getLerCodes() {
        if (!itiTokenService.hasToken()) { return; }
        const res = await itiHttpService.get(API.lerCode);
        this.context.commit('updateLerCodes', res);
    }

    @Mutation
    public updateLerCodes(items: LerCode[]) {
        this.lerCodes = items;
    }

    @Action
    public async insertarLerCode(item: LerCode){
        if (!itiTokenService.hasToken()) { return; }
        const res = await itiHttpService.post(API.lerCode, item, false);
        this.context.dispatch('getLerCodes');
    }

    @Action
    public async modificarLerCode(item: LerCode){
        if (!itiTokenService.hasToken()) { return; }
        try{
            const res = await itiHttpService.put(API.lerCode, item, false);
        } catch {
            // ..
        }
        this.context.dispatch('getLerCodes');
    }

    @Action
    public async eliminarLerCode(id: number){
        if (!itiTokenService.hasToken()) { return; }
        const apiDeleteLerCode = ItiString.Format(API.lerCodeDetail, id);
        const res = await itiHttpService.delete(apiDeleteLerCode, id, false);
        this.context.dispatch('getLerCodes');
    }    
}

export default getModule(LerCodeModule);